/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";

const RoomTypeIcon = ({ isActive = false, className = "" }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, "")} test-id="huujbRM5">

      <path
        d="M0.411865 12.3819V7.33988C0.411865 6.96173 0.486007 6.61859 0.634292 6.31046C0.782576 6.00234 0.978042 5.72923 1.22069 5.49114V3.1382C1.22069 2.43792 1.4566 1.84268 1.92841 1.35248C2.40022 0.862286 2.97314 0.617188 3.64716 0.617188H6.88245C7.1925 0.617188 7.48233 0.676851 7.75194 0.796179C8.02155 0.914946 8.27093 1.07937 8.5001 1.28946C8.72927 1.07937 8.97865 0.914946 9.24826 0.796179C9.51787 0.676851 9.8077 0.617188 10.1177 0.617188H13.353C14.0271 0.617188 14.6 0.862286 15.0718 1.35248C15.5436 1.84268 15.7795 2.43792 15.7795 3.1382V5.49114C16.0222 5.72923 16.2176 6.00234 16.3659 6.31046C16.5142 6.61859 16.5883 6.96173 16.5883 7.33988V12.3819H14.9707V10.7012H2.02951V12.3819H0.411865ZM9.30892 4.81887H14.1619V3.1382C14.1619 2.9001 14.0842 2.70038 13.9289 2.53904C13.7742 2.37825 13.5822 2.29786 13.353 2.29786H10.1177C9.88858 2.29786 9.69662 2.37825 9.54187 2.53904C9.38657 2.70038 9.30892 2.9001 9.30892 3.1382V4.81887ZM2.83834 4.81887H7.69128V3.1382C7.69128 2.9001 7.6139 2.70038 7.45915 2.53904C7.30385 2.37825 7.11162 2.29786 6.88245 2.29786H3.64716C3.41799 2.29786 3.22576 2.37825 3.07047 2.53904C2.91571 2.70038 2.83834 2.9001 2.83834 3.1382V4.81887ZM2.02951 9.02055H14.9707V7.33988C14.9707 7.10178 14.893 6.90206 14.7377 6.74072C14.583 6.57993 14.391 6.49954 14.1619 6.49954H2.83834C2.60917 6.49954 2.41694 6.57993 2.26164 6.74072C2.10689 6.90206 2.02951 7.10178 2.02951 7.33988V9.02055Z"
        fill={fill} test-id="1YIhxb8_" />

    </svg>);

};

export default RoomTypeIcon;